import { combineReducers } from "redux";
import invoices from "./invoices";
import settings from "./settings";
import customerContacts from "./customer-contacts";
import customerDeliveryLocations from "./customer-delivery-locations";

export default combineReducers({
  invoices,
  settings,
  customerContacts,
  customerDeliveryLocations,
});
